export default "__VITE_ASSET__BQzeRZLm__"